/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { selectUserDiCode } from '@landscape/ui-redux'
import { FILE_TYPES, Spinner } from '@landscape/ui-lib'
import { downloadAnyFileFromS3 } from 'contextUtil'

const StyledDownloadIcon = styled.div`
  display: flex;
  cursor: pointer;
`

interface FileDownloadLinkProps {
  type: FILE_TYPES
  originalFileName: any
  jobId?: any
  ariaLabel?: any
  ariaDescribedBy?: any
  onFileDoesNotExist?: Function
}

export const FileDownloadLink = ({
  type,
  originalFileName,
  jobId,
  ariaLabel = 'Download File',
  ariaDescribedBy,
  onFileDoesNotExist,
}: FileDownloadLinkProps) => {
  const [loading, setLoading] = useState(false)

  const di_code = useSelector(selectUserDiCode) as string

  const handleFileDownload = async (e: any) => {
    e.preventDefault()
    const metadata = {
      di_code,
      jobId,
      originalFileName,
      type,
    }
    await downloadAnyFileFromS3({ metadata, setLoading, onFileDoesNotExist })
  }

  return (
    <div>
      <StyledDownloadIcon className="download-icon-div" onClick={handleFileDownload}>
        {!loading ? (
          <button
            type="button"
            className="file-download-btn cb-btn cb-btn-naked cb-no-padding-top cb-no-padding-bottom cb-no-padding-right cb-font-size-regular"
            aria-label={ariaLabel}
            aria-describedby={ariaDescribedBy}
            style={{ paddingLeft: '8px' }}
            data-testid="file-download-btn"
          >
            {type === FILE_TYPES.QC ? 'Download' : originalFileName}
          </button>
        ) : (
          <Spinner showSpinner={true} size="xs" id="agg-file-download" ariaLabel="Downloading..." />
        )}
      </StyledDownloadIcon>
    </div>
  )
}

export const FileDownloadLinkWrapper = (props: any) => {
  return (
    <>
      <div style={{ margin: '0px auto' }}>{props.row.fileName}</div>
      <FileDownloadLink
        type={FILE_TYPES.JOB}
        jobId={props.row.id.toString()}
        originalFileName={props.row.fileName}
      />
    </>
  )
}
